import React, { useState, useRef } from "react";
import {
  Typography,
  Divider,
  OldButton as Button,
  TextInput,
  Stack,
  Spacer,
  ModalContent,
  Box,
} from "digiwash-components";

import Modal from "../ReactNativeModal";

import Icon from "../Icon";

interface PropTypes {
  isVisible: boolean;
  disabled?: boolean;
  selectedLocation: any;
  onBack: () => void;
  onSave: (title: string, address: string) => void;
}

function MapAddressForm(props: PropTypes) {
  let [title, setTitle] = useState("");
  let [address, setAddress] = useState("");
  let addressRef = useRef();
  let canSubmitForm = !props.disabled && !!title && !!address;
  let onSubmitForm = () => {
    if (canSubmitForm) {
      props.onSave(title, address);
    }
  };

  return (
    <Modal
      isVisible={props.isVisible}
      onBackdropPress={props.onBack}
      style={{ justifyContent: "flex-end", margin: 0 }}
    >
      <ModalContent title="افزودن آدرس منتخب">
        <Box p="l">
          <TextInput
            value={title}
            onChangeText={(t) => setTitle(t)}
            placeholder="نام (مثال: خانه، محل کار و ...)"
            onSubmitEditing={() => {
              if (addressRef.current) {
                //@ts-ignore
                addressRef.current.focus();
              }
            }}
          />
          <Divider size="l" />
          <TextInput
            value={address}
            onChangeText={(t) => setAddress(t)}
            placeholder="آدرس دقیق برای مسیریابی راننده"
            ref={addressRef}
            onSubmitEditing={onSubmitForm}
          />
          <Divider size="l" />
          <Button
            onPress={onSubmitForm}
            size="l"
            type="circle-like"
            bg="green.main"
            disabled={!canSubmitForm}
          >
            <Stack distribution="center">
              <Typography color="common.white" ff="mainBold">
                افزودن آدرس
              </Typography>
              <Spacer size="m" />
              <Icon color="common.white" name="arrow-left" size={16} />
            </Stack>
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
}

export default MapAddressForm;
